import { useCallback, useEffect, useMemo, useState } from "react"
import { useDirect } from "../pages/direct/match/DirectContext.js"
import { useDispatch } from "react-redux"
import { updateMatch } from "../../actions/matchs.js"
import { getAllMatchPeriods, getMinTotalDuration } from "../sports/rules.js"
import { getPeriodEvents } from "../pages/direct/match/data/gameEvents.js"
import StyledPeriodButton from "../pages/direct/match/components/buttons/StyledPeriodButton.js"

export const useMatchTimer = () => {

    const dispatch = useDispatch()
    const match = useDirect()

    const timeOffset = useMemo(() => {
        return getMinTotalDuration(match.period, match.discipline) * 60
    }, [match.period, match.discipline])

    const [timer, setTimer] = useState(match.timer); // Temps en secondes
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {

        if(match.statusTimer === 'off'){
            setIsRunning(false)
        }else if(match.statusTimer === 'on'){
            setIsRunning(true)
        }

    }, [,match.statusTimer])

    useEffect(() => {
        //if(match.statusTimer === 'off')
            setTimer(match.timer)
    }, [match.timer])

    useEffect(() => {

        let interval = null;
        if (isRunning) {
          interval = setInterval(() => {
            setTimer((prevTime) => prevTime + 1);
          }, 1000);
        } else {
          clearInterval(interval);
        }
        return () => clearInterval(interval);
      }, [isRunning]);

    function changeStatusTimer(){

        dispatch(updateMatch(match._id, {
            timer,
            statusTimer : !isRunning ? 'on' : 'off', 
            lastUpdateStatus : new Date()
        }))
    }

    function startPeriod(period){

        // On ne démarre pas le chrono au basket
        const statusTimer = match.discipline === 'basket' ? 'off' : 'on'
        const timer = match.discipline === 'basket' ? 1 : 0

        dispatch(updateMatch(match._id, {
            statusTimer,
            period,
            timer, 
            lastUpdateStatus : new Date()
        }))
    }

    function stopPeriod(period, status = 'normal'){
        setTimer(0)

        dispatch(updateMatch(match._id, {
            statusTimer : 'off',
            period,
            timer : 0, 
            status,
            lastUpdateStatus : new Date()
        }))
    }

    function getColorControleur(){
            return match.statusTimer === 'on' || match.timer !== 0 ? 'success' : 'error'
    }

    const getPeriodAction = useCallback((handleEventClick) => {

        let title, textButton, isStart
        let onClickParam

        let allPeriods = getAllMatchPeriods(match.discipline);

        let actualMatchPeriod = match.period

        if(['soccer', 'rugby'].includes(match.discipline)){
            // démarré
            if(match.statusTimer==='on' || match.timer !== 0 || match.period === 5){
                if(match.period===0){
                    actualMatchPeriod = 1
                }
                else if(match.period===1){
                    actualMatchPeriod = 3
                }
                else if(match.period===3){
                    actualMatchPeriod = 5
                }
                else if(match.period===4){
                    actualMatchPeriod = 7
                }
                else if(match.period===5){
                    actualMatchPeriod = 9
                }
            }
            // Pas démarré
            else if(match.timer === 0 && match.statusTimer==='off'){
                if(match.period===0){
                    actualMatchPeriod = 0
                }
                else if(match.period===1){
                    actualMatchPeriod = 2
                }
                else if(match.period===3){
                    actualMatchPeriod = 4
                }
                else if(match.period===4){
                    actualMatchPeriod = 6
                }
                else if(match.period===5){
                    actualMatchPeriod = 8

                }else if(match.period===2 || match.period===6){
                    actualMatchPeriod = 10
                }
            }
        }

        if(['basket'].includes(match.discipline)){
            // démarré
            if(match.statusTimer==='on' || match.timer !== 0){
                    actualMatchPeriod = 2*match.period+1
            }
            // Pas démarré
            else if(match.timer === 0 && match.statusTimer==='off'){
                    actualMatchPeriod = 2*match.period
            }
        }

        let nextMatchPeriod = actualMatchPeriod+1

        let matchPeriod = allPeriods.get(actualMatchPeriod);
        let nextPeriod = allPeriods.get(nextMatchPeriod);

        if(!nextPeriod){
            isStart = false
        }else{
            isStart = matchPeriod && nextPeriod.isPlayable;
        }

        title = isStart ? 'Début ' + nextPeriod.name : 'Fin ' +  matchPeriod.name;
        textButton = isStart 
            ? 'Début ' + nextPeriod.name 
            : (matchPeriod.name === 'Match terminé' 
                ? matchPeriod.name 
                : 'Fin ' + matchPeriod.name);

        const periodEvent = getPeriodEvents(match.discipline)

        if(isStart){
            onClickParam = () => { handleEventClick({...periodEvent[0], isEnableTrigger : actualMatchPeriod===0}, (event) => {
                startPeriod(match.discipline === 'handball' ? nextPeriod.matchPeriod : matchPeriod.matchPeriod)
            }) }
        }else{
            onClickParam = () => { handleEventClick(periodEvent[1], (event) => {
                const entries = Array.from(allPeriods.entries());
                
                // On regarde l'event saisi par l'utilisateur pour savoir quel est le nextPeriod
                if(event.detail.reason === "end"){
                    let lastPeriodIndex = entries.length - 1; // Get the last entry
                    const lastPeriod = allPeriods.get(lastPeriodIndex)
                    stopPeriod(lastPeriod.matchPeriod, 'end')
                }else if(event.detail.reason === "tab"){
                    let preLastPeriodIndex = entries.length - 2; // Get the last entry
                    const preLastPeriod = allPeriods.get(preLastPeriodIndex)
                    stopPeriod(preLastPeriod.matchPeriod)
                }else if(event.detail.reason === "next"){
                    stopPeriod(nextPeriod.matchPeriod)
                }
                

            }) }
        }

       return <StyledPeriodButton onClick={onClickParam} disabled={!nextPeriod} text={textButton} />

        // return <Button onClick={onClickParam} disabled={!nextPeriod} sx={{fontSize : '0.8em'}} color={getColorControleur()} variant="contained">{textButton}</Button>
    }, [match])

    function updateMatchChrono(payload){
        const {period} = payload

        let status
        // Si period vaut la derniere des periodes, alors status = 'end', sinon status = 'normal'
        const allPeriods = getAllMatchPeriods(match.discipline)
        const periodEntries = [...allPeriods.entries()]
        const lastPeriod = periodEntries[periodEntries.length - 1];

        if(lastPeriod && lastPeriod[1].matchPeriod === period)
            status = 'end'
        else
            status = 'normal'

        dispatch(updateMatch(match._id, {...payload, status}))
    }

    function getCurrentMatchPeriodName() {
        const allPeriods = getAllMatchPeriods(match.discipline);
        let actualMatchPeriod = match.period;

        if (['soccer', 'rugby'].includes(match.discipline)) {
            if (match.statusTimer === 'on' || match.timer !== 0 || match.period === 5) {
                if (match.period === 0) actualMatchPeriod = 1;
                else if (match.period === 1) actualMatchPeriod = 3;
                else if (match.period === 3) actualMatchPeriod = 5;
                else if (match.period === 4) actualMatchPeriod = 7;
                else if (match.period === 5) actualMatchPeriod = 9;
            } else {
                if (match.period === 0) actualMatchPeriod = 0;
                else if (match.period === 1) actualMatchPeriod = 2;
                else if (match.period === 3) actualMatchPeriod = 4;
                else if (match.period === 4) actualMatchPeriod = 6;
                else if (match.period === 5) actualMatchPeriod = 8;
                else if (match.period === 2 || match.period === 6) actualMatchPeriod = 10;
            }
        } else if (['basket'].includes(match.discipline)) {
            actualMatchPeriod = match.statusTimer === 'on' || match.timer !== 0
                ? 2 * match.period + 1
                : 2 * match.period;
        }

        const matchPeriod = allPeriods.get(actualMatchPeriod);
        return matchPeriod?.name ?? "";
    }

    return { changeStatusTimer, getPeriodAction, updateMatchChrono, timer, period : match.period, isRunning, timeOffset, getCurrentMatchPeriodName }

}